import React, { useCallback, useRef, useState } from 'react';
import { KeyboardIcon } from 'lucide-react';
import { Popover } from '../ui/Popover';

const shortcuts = [
  { keys: ['/'], label: 'Search registrations' },
  { keys: ['↑', '↓'], label: 'Move between rows' },
  { keys: ['Enter'], label: 'Open details' },
  { keys: ['X'], label: 'Select focused row' },
  { keys: ['J', 'K'], label: 'Next / previous in panel' },
  { keys: ['Esc'], label: 'Close panel or menu' },
];

export function ShortcutsMenu() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Keyboard shortcuts"
        title="Keyboard shortcuts"
        className="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-text-neutral-500 tw-transition-colors tw-duration-150 hover:tw-bg-sand-50 hover:tw-text-neutral-900">
        <KeyboardIcon className="tw-h-4 tw-w-4" />
      </button>
      <Popover anchorRef={anchorRef} open={open} onClose={close} align="end" label="Keyboard shortcuts" width={264}>
        <p className="tw-border-b tw-border-neutral-200 tw-px-3 tw-py-2.5 tw-text-xs tw-font-medium tw-text-neutral-500">Keyboard shortcuts</p>
        <dl className="tw-m-0 tw-space-y-2 tw-p-3">
          {shortcuts.map(s => (
            <div key={s.label} className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-text-sm">
              <dt className="tw-font-normal tw-text-neutral-900">{s.label}</dt>
              <dd className="tw-m-0 tw-flex tw-shrink-0 tw-gap-1">
                {s.keys.map(k => (
                  <kbd key={k} className="tw-min-w-6 tw-rounded tw-border tw-border-neutral-200 tw-bg-sand-50 tw-px-1.5 tw-py-px tw-text-center tw-font-sans tw-text-xs tw-text-neutral-500 tw-shadow-none">
                    {k}
                  </kbd>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      </Popover>
    </>
  );
}
